import { type AmountPrice } from '@kijiji/generated/graphql-types'

import { type VipQueryPrice } from '@/types/listings'

export const isAmountPrice = (listingPrice?: VipQueryPrice): listingPrice is AmountPrice => {
  if (
    listingPrice &&
    (listingPrice?.__typename === 'AutosDealerAmountPrice' ||
      listingPrice?.__typename === 'StandardAmountPrice' ||
      'amount' in listingPrice)
  ) {
    return true
  }

  return false
}
